"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Layout = _interopRequireDefault(require("../../components/Layout"));
var _Header = _interopRequireDefault(require("../../components/Header"));
var _Webmail = _interopRequireDefault(require("../../components/Webmail"));
var _Offer = require("../../components/Offer");
var _Graph = _interopRequireDefault(require("../../components/Graph"));
var _PriceMatrix = require("../../components/PriceMatrix");
var _SearchForm = _interopRequireDefault(require("../../components/SearchForm"));
var _Footer = _interopRequireDefault(require("../../components/Footer"));
var _Partner = require("../../contexts/Partner");
var _Subscription = require("../../components/Subscription");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PriceWatch = function PriceWatch(_ref) {
  var layout = _ref.layout,
    webmail = _ref.webmail,
    partner = _ref.partner,
    header = _ref.header,
    offer = _ref.offer,
    graph = _ref.graph,
    priceMatrix = _ref.price_matrix,
    organization = _ref.organization,
    unsubscribe = _ref.unsubscribe,
    webView = _ref.webView;
  var footer = _objectSpread(_objectSpread({}, organization), unsubscribe);
  return /*#__PURE__*/_react["default"].createElement(_Partner.PartnerContextProvider, {
    value: partner
  }, /*#__PURE__*/_react["default"].createElement(_Layout["default"], layout, !webView && /*#__PURE__*/_react["default"].createElement(_Webmail["default"], webmail), /*#__PURE__*/_react["default"].createElement(_Header["default"], (0, _extends2["default"])({
    webView: webView
  }, header)), webView && /*#__PURE__*/_react["default"].createElement(_Subscription.Subscription, {
    onClick: webView.subscriptionAction,
    loading: webView.loading,
    success: webView.success
  }), /*#__PURE__*/_react["default"].createElement(_Offer.Offer, offer), graph && /*#__PURE__*/_react["default"].createElement(_Graph["default"], graph), priceMatrix && /*#__PURE__*/_react["default"].createElement(_PriceMatrix.PriceMatrix, {
    targetDuration: offer.nights_count,
    priceMatrix: priceMatrix.matrix,
    surcharges: priceMatrix.surcharges
  }), !webView && /*#__PURE__*/_react["default"].createElement(_SearchForm["default"], null), !webView && /*#__PURE__*/_react["default"].createElement(_Footer["default"], footer)));
};
var _default = exports["default"] = PriceWatch;